(() => {
  const init = () => {
    document.querySelectorAll('[data-sdl-gallery]').forEach(gallery => {
      if (gallery.dataset.sdlReady) return;
      gallery.dataset.sdlReady = 'true';
      const track = gallery.querySelector('.sdl-project-track');
      const slides = [...track.children];
      const prev = gallery.querySelector('[data-sdl-prev]');
      const next = gallery.querySelector('[data-sdl-next]');
      const count = gallery.querySelector('[data-sdl-count]');
      let index = 0;
      const update = () => {
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        count.textContent = index + 1;
        prev.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      const go = step => {
        index = Math.max(0, Math.min(slides.length - 1, index + step));
        track.scrollTo({ left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          go(event.key === 'Home' ? -index : event.key === 'End' ? slides.length - 1 - index : event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      new ResizeObserver(update).observe(track);
      gallery.querySelector('.sdl-gallery-controls').hidden = false;
      update();
    });
    document.querySelectorAll('.sdl-project-video').forEach(wrapper => {
      if (wrapper.dataset.sdlReady) return;
      wrapper.dataset.sdlReady = 'true';
      const video = wrapper.querySelector('video');
      const play = wrapper.querySelector('.sdl-video-play');
      play.hidden = false;
      play.addEventListener('click', () => {
        play.hidden = true;
        video.play().catch(() => { play.hidden = false; });
      });
      video.addEventListener('play', () => { play.hidden = true; });
      video.addEventListener('ended', () => { play.hidden = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Saunamo designer country + consent-gated attribution handoff, 2026-09-28. */
(() => {
  const market = ({'saunamo.pt':'PT','saunamo.es':'ES','saunamo.fr':'FR','saunamo.it':'IT','saunamo.co.uk':'GB','saunamo.us':'US','saunamo.shop':'OTHER'})[location.hostname.replace(/^www\./,'')];
  if (!market) return;
  const keys = ['gclid','gbraid','wbraid','gclsrc','gad_source','gad_campaignid','_gl','fbclid','utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term'];
  const allowed = () => window.saunamoCampaignTracking?.allowed() === true;
  const decorate = link => {
    try {
      const url = new URL(link.href);
      if (url.origin !== 'https://designer.saunamo.pt') return;
      url.searchParams.set('country', market);
      url.searchParams.set('lang', ({PT:'pt',ES:'es',FR:'fr',IT:'it',GB:'en',US:'en',OTHER:'en'})[market]);
      const source = window.saunamoCampaignTracking?.read() || {};
      for (const key of keys) {
        if (!allowed()) { url.searchParams.delete(key); continue; }
        const value = source[key];
        url.searchParams.delete(key);
        if (value && value.length <= 2048 && !/[\r\n<>]/.test(value)) url.searchParams.set(key, value);
      }
      link.href = url.toString();
    } catch {}
  };
  const refresh = () => document.querySelectorAll('a[data-designer-cta]').forEach(decorate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('saunamo:consent-updated', refresh);
  document.addEventListener('click', event => { const link = event.target.closest?.('a[data-designer-cta]'); if (link) decorate(link); }, true);
})();
